import React, { useState } from "react";
import { auth, googleProvider } from "../firebase";
import { signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleAuth = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      if (isRegister) {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(userCredential.user, {
          displayName: `${firstName} ${lastName}`.trim(),
        });
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
      onLogin(auth.currentUser);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    setError("");
    try {
      await signInWithPopup(auth, googleProvider);
      onLogin(auth.currentUser);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-container">
        <div className="bg-white border border-gray-300 rounded-lg p-8 w-full max-w-md login-box">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          {isRegister ? "Create Account" : "Welcome Back"}
        </h2>
        <form onSubmit={handleAuth} className="flex flex-col gap-4 w-full">
          <div className="space-y-2">
            {isRegister && (
              <>
                <div>
                    <input
                    className="form-input"
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                    />
                </div>
                <div>
                    <input
                    className="form-input"
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                    />
                </div>
              </>
            )}
            <div>
                <input
                className="form-input"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div>
                <input
                className="form-input"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                />
            </div>
          </div>
          {error && (
            <p className="error-message">
              {error}
            </p>
          )}
          <button type="submit" className="button-primary button-spacing w-full" disabled={isLoading}>
            {isLoading ? (
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem'}}>
                <div className="loader" style={{width: '20px', height: '20px', borderWidth: '3px'}} aria-hidden="true" />
                <span>{isRegister ? "Creating Account..." : "Signing In..."}</span>
              </div>
            ) : (isRegister ? "Create Account" : "Sign In")}
          </button>
        </form>

        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
        </div>

        <button
          onClick={handleGoogleLogin}
          className="w-full flex items-center justify-center gap-2 button-secondary"
          disabled={isLoading}
        >
          {isLoading ? (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem'}}>
              <div className="loader" style={{width: '20px', height: '20px', borderWidth: '3px'}} aria-hidden="true" />
              <span>Signing In...</span>
            </div>
          ) : (
            <>
              <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{display: 'inline-block', verticalAlign: 'middle'}}>
                <path
                  fill="currentColor"
                  d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z"
                />
              </svg>
              Sign in with Google
            </>
          )}
        </button>

        <p className="text-center mt-6">
          <span
            onClick={() => {
              setIsRegister(!isRegister);
              setFirstName("");
              setLastName("");
              setEmail("");
              setPassword("");
              setError("");
            }}
            className="account-toggle"
          >
            {isRegister
              ? "Already have an account? Sign in"
              : "New user? Create account"}
          </span>
        </p>
      </div>
    </div>
  );
}
